exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "iframe[data-v-a65e6c6c]{width:100%;height:90vh}", ""]);

// exports
